import {autoImplement} from '@/util';
import {ApiArticleEAN} from './ArticleEAN';
import {ApiArticleGebinde} from './ArticleGebinde';
import {ApiArticlePalette} from './ArticlePalette';
import {ApiCharge} from './Charge';
import {ApiNVE} from './NVE';
import {Moment} from 'moment';
import {ApiArticlePrice, ArticlePrice} from '@/model/ArticlePrice';

export interface GeneralArticle {
  ArtikelNr: string;
  Bezeichnung1: string;
  Bezeichnung2: string;
  Beschreibung?: string;
  ArtikelArt: string;
  // ArtikelBestaende: ApiArticleStock[];
  EANCode: string;
  GruppeBezeichnung: string;
  EinheitBezeichnung: string;
  EinheitBezeichnungLang: string;
  Gewicht: number|null;
  SerienNummer: 'J'|'N';
  ChargenNummer: 'J'|'N';
  HauptGebinde: {
    GebindeSchluessel: number;
    GebindeBezeichnung: string;
    GebindeInhalt: number;
  } | null;
  ArtikelEAN: ApiArticleEAN[];
  ArtikelGebinde: ApiArticleGebinde[];
  ArtikelPaletten: ApiArticlePalette[];
  VerfuegbareNVEs: ApiNVE[];
  VerfuegbareChargen?: {
    Chargen: ApiCharge[];
  }
  LetztesEKDatum: Moment|null;
  LetztesVKDatum: Moment|null;
  PE1: number;
  // incompl
}

export interface ArticleFilters {
  Artikelnr$In: string[];
}

export interface ApiArticle extends GeneralArticle {
  ArtikelPreise?: ApiArticlePrice[];
  // incompl
}

export interface ArticleInterface extends GeneralArticle {
  ArtikelPreise?: ArticlePrice[];
}

export default class Article extends autoImplement<ArticleInterface>() {
  static fromApi(apiArticle: ApiArticle): Article {
    return new Article({
      ...apiArticle,
      ArtikelPreise: apiArticle.ArtikelPreise?.map((price) => ArticlePrice.fromApi(price)),
    });
  }

  get currentPrices() : ArticlePrice[] {
    return this.ArtikelPreise?.filter((price) => price.isActive).sort((a, b) => (a.AbMenge ?? 0) - (b.AbMenge ?? 0)) ?? [];
  }

  getBeschreibung() : string|undefined {
    if (!this.Beschreibung) return undefined;

    return this.Beschreibung.replaceAll('\r\n', '<br/>');
  }
}
